import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import 'core-js/stable';
// Authentication
import { runWithAdal } from "react-adal";
import { authContext } from "lib/js/adalConfig";
// Check

runWithAdal(authContext, () => {
	import("./surveyApp.js");
});
